export default __webpack_public_path__ + "static/media/Me.9b4f20b1.jpg";